/*
 *
 * */

import { Checkbox, CheckboxList, CheckboxItem } from '@/lib/formFactory/checkbox.interface';
export default class CheckboxEntity {
    defaultValue: Checkbox;
    entityName: string;
    entity: any;

    constructor(name: string) {
        this.defaultValue = {
            key: name,
            name: name,
            type: 'checkbox',
            list: {
                0: {
                    id: 1,
                    name: 'Активен',
                    checked: true,
                } as CheckboxItem,
            },
            handler: '',
        };
        this.entityName = name;
        this.entity = this.defaultValue;
    }

    setTitle(title: string) {
        this.entity['title'] = title;
    }

    setName(name: string) {
        this.entity['name'] = name;
    }

    setList(list: CheckboxList) {
        this.entity['list'] = list;
    }

    setAction(handler: string) {
        this.entity['handler'] = handler;
    }
}
